import { Heading } from "@/components/heading/Heading";
import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";
import { ButtonsContainer, FlexDiv } from "@repo/ui";
import React from "react";

export interface ActionTitleProps {
  title: string;
  action?: React.ReactNode;
}

const ActionTitleContainer = styled(FlexDiv)`
  border-bottom: ${Variables.thicknessThick} solid ${LightMode.colourNeutral7};
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${Variables.space50};
  min-height: 50px;
`;

export const ActionTitle = ({ title, action }: ActionTitleProps) => {
  return (
    <ActionTitleContainer>
      <Heading textStyle="Heading.S">{title ?? ""}</Heading>
      <ButtonsContainer>{action}</ButtonsContainer>
    </ActionTitleContainer>
  );
};
